<template>
  <v-container fluid class="pa-4 pa-sm-6">
    <!-- Шапка страницы -->
      <PageTitle title="Задать вопрос эксперту" />
      <v-alert class=" mb-4" text="Выберите тему, сформулируйте вопрос и получите ответ от преподавателя." type="info" variant="tonal"></v-alert>


    <v-row>
      <!-- ЛЕВАЯ КОЛОНКА (на мобильном — сверху): Форма создания вопроса -->
      <v-col cols="12" md="5" lg="4">
        <v-card class=" rounded-lg" outlined elevation="1">

          <v-card-title class=" d-flex align-center justify-space-between text-h6 font-weight-bold bg-deep-orange-darken-1">
            Новый вопрос
          </v-card-title>

          <v-form ref="form" v-model="isFormValid" @submit.prevent="submitQuestion" class="pa-4">
            <!-- Выбор темы из выпадающего списка -->
            <v-select
              v-model="newQuestion.topicId"
              :items="topics"
              item-title="topicTitle"
              item-value="id"
              label="Выберите тему вопроса"
              variant="outlined"
              density="comfortable"
              :rules="[v => !!v || 'Тема обязательна для выбора']"
              class="mb-2"
              prepend-inner-icon="mdi-tag-outline"
            ></v-select>

            <!-- Поле ввода вопроса -->
            <v-textarea
              v-model="newQuestion.questionBody"
              label="Ваш вопрос преподавателю"
              variant="outlined"
              density="comfortable"
              rows="5"
              auto-grow
              counter
              maxlength="1000"
              :rules="[
                v => !!v || 'Введите текст вопроса',
                v => (v && v.length >= 10) || 'Вопрос должен быть не менее 10 символов'
              ]"
              placeholder="Опишите вашу проблему или вопрос как можно подробнее..."
              class="mb-4"
            ></v-textarea>
            <!-- Кнопка отправки -->
            <v-btn
              type="submit"
              color="deep-orange-darken-1"
              size="large"
              :loading="isSubmitting"
              :disabled="!isFormValid"
              block
              class="font-weight-bold"
            >
              <v-icon start>mdi-send</v-icon>
              Отправить эксперту
            </v-btn>
          </v-form>
        </v-card>
      </v-col>

      <!-- ПРАВАЯ КОЛОНКА (на мобильном — снизу): История вопросов -->
      <v-col cols="12" md="7" lg="8">
        <v-card class=" rounded-lg" outlined elevation="1">
          <v-card-title class=" d-flex align-center justify-space-between text-h6 font-weight-bold bg-deep-orange-darken-1">
            История ваших вопросов
            <v-btn icon="mdi-refresh" variant="text" size="small" @click="fetchMyQuestions" :loading="isHistoryLoading"></v-btn>
          </v-card-title>

          <!-- 📱 МОБИЛЬНАЯ ВЕРСТКА: Список карточек (скрыт на экранах от sm и выше) -->
          <div class="d-block d-sm-none mt-3">
            <v-card
              v-for="item in qaHistory"
              :key="item.id"
              class="mb-3 ml-3 mr-3 pa-3 rounded-lg"
              variant="outlined"
            >
              <div class="d-flex justify-space-between align-center mb-2">
                <span class="text-caption text-grey">{{ formatDate(item.createdAt) }}</span>
                <v-chip :color="getStatusColor(item.status)" size="x-small" class="text-uppercase font-weight-bold">
                  {{ getStatusText(item.status) }}
                </v-chip>
              </div>
              <div class="text-deep-orange-darken-1 text-caption font-weight-bold mb-1">Тема: {{ item.qaTopic?.topicTitle }}</div>
              <div class="text-body-2 font-weight-medium mb-2 text-truncate-3">«{{ item.questionBody }}»</div>

              <!-- Отображение ответа на мобильном -->
              <div v-if="item.answerBody" class="bg-grey-lighten-4 pa-2 rounded mt-2 text-body-2 text-grey-darken-3">
                <div class="font-weight-bold text-caption text-deep-orange-darken-1">Ответ преподавателя:</div>
                {{ item.answerBody }}
              </div>
            </v-card>
            <div v-if="qaHistory.length === 0" class="text-center py-6 text-grey">Вы еще не задавали вопросов</div>
          </div>

         <!-- 💻 ДЕСКТОПНАЯ ВЕРСТКА: Таблица (скрыта на мобильных) -->
                   <v-data-table
                     items-per-page-text="Записей на странице:"

                     :headers="headers"
                     :items="qaHistory"
                     :loading="isHistoryLoading"
                     class="d-none d-sm-block mt-2 background-transparent"
                     no-data-text="Вы еще не задавали вопросов"
                     loading-text="Загрузка истории..."
                     show-expand
                   >

                     <!-- Слот для кастомного отображения Вопроса -->
                     <template v-slot:[`item.question`]="{ item }">
                       <div class="font-weight-bold text-deep-orange-darken-1 text-caption mb-1">{{ item.qaTopic?.topicTitle }}</div>
                       <div class="text-body-2 text-truncate-2" v-text="item.questionBody"></div>
                     </template>

                     <!-- Слот для цветного Статуса -->
                     <template v-slot:[`item.status`]="{ item }">
                       <v-chip :color="getStatusColor(item.status)" size="small" class="text-uppercase font-weight-bold">
                         {{ getStatusText(item.status) }}
                       </v-chip>
                     </template>

                     <!-- Слот для Форматирования Даты -->
                     <template v-slot:[`item.createdAt`]="{ item }">
                       <span class="text-caption text-grey-darken-1">{{ formatDate(item.createdAt) }}</span>
                     </template>

                     <!-- Раскрывающаяся строка с ответом при клике на стрелочку в таблице -->
                     <template v-slot:[`expanded-row`]="{ columns, item }">
                       <tr>
                         <td :colspan="columns.length" class="bg-grey-lighten-5 pa-4">
                           <div class="font-weight-bold text-deep-orange-darken-1 mb-1">
                             <v-icon size="small" class="mr-1">mdi-comment-account-outline</v-icon>
                             Ответ преподавателя:
                           </div>
                           <div class="text-body-2 text-grey-darken-3 whitespace-pre-line" v-if="item.answerBody">
                             {{ item.answerBody }}
                           </div>
                           <div class="text-body-2 text-grey-darken-1 italic" v-else>
                             Ожидает проверки преподавателем. Как только ответ будет дан, он появится здесь.
                           </div>
                         </td>
                       </tr>
                     </template>
                   </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script setup>
import { ref, onMounted } from 'vue'
import PageTitle from "@/elements/PageTitle.vue";

// Управление состоянием элементов UI
const isFormValid = ref(false)
const isSubmitting = ref(false)
const isHistoryLoading = ref(false)
const form = ref(null)
import { customAxios } from "@/service/customAxios";

// Реактивный объект для отправки на бэкенд
const newQuestion = ref({
  topicId: null,
  questionBody: ''
})

// Списки данных
const topics = ref([])
const qaHistory = ref([])

// Конфигурация заголовков для v-data-table (десктопная версия)
const headers = [
  { title: 'Дата создания', key: 'createdAt', width: '20%' },
  { title: 'Вопрос', key: 'question', width: '55%' },
  { title: 'Статус', key: 'status', width: '15%', align: 'center' },
  { title: 'Ответ', key: 'data-table-expand', width: '10%' }
]

// Цветовая разметка статусов жизненного цикла QAPairStatus
const getStatusColor = (status) => {
  switch (status) {
    case 'PENDING': return 'warning'   // В очереди (оранжевый)
    case 'ANSWERED': return 'info'     // На проверке (черновик, синий)
    case 'APPROVED': return 'success'  // В базе RAG (зеленый)
    default: return 'grey'
  }
}

// Понятный перевод статусов для студента
const getStatusText = (status) => {
  switch (status) {
    case 'PENDING': return 'В очереди'
    case 'ANSWERED': return 'На проверке'
    case 'APPROVED': return 'Ответ готов'
    default: return status
  }
}

// Форматирование даты под локальные стандарты (DD.MM.YYYY, HH:MM)
const formatDate = (dateString) => {
  if (!dateString) return ''
  return new Date(dateString).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

// Интеграция с API: Загрузка списка доступных тем (GET /api/v1/topics)
const fetchTopics = async () => {
  try {
    const res = await customAxios.get('/v1/topics')
    topics.value = res.data

  } catch (e) {
    console.error('Ошибка загрузки тем:', e)
  }
}

// Интеграция с API: Загрузка истории вопросов студента (GET /api/v1/student/qa/my)
const fetchMyQuestions = async () => {
  isHistoryLoading.value = true
  try {
    const res = await customAxios.get('/v1/student/qa/my')
    qaHistory.value = res.data

  } catch (e) {
    console.error('Ошибка загрузки истории:', e)
  } finally {
    isHistoryLoading.value = false
  }
}

// Интеграция с API: Отправка формы (POST /api/v1/student/qa)
const submitQuestion = async () => {
  if (!isFormValid.value) return
  isSubmitting.value = true
  try {
    const res = await customAxios.post('/v1/student/qa', newQuestion.value)

    // Эмуляция успешного сброса полей формы
    if(res.status === 201){
       newQuestion.value.questionBody = ''
        newQuestion.value.topicId = null
        form.value?.resetValidation()
        // Обновляем список вопросов в таблице
        await fetchMyQuestions()
    }

  } catch (e) {
    console.error('Ошибка отправки вопроса:', e)
  } finally {
    isSubmitting.value = false
  }
}

// Хук жизненного цикла для первичной инициализации данных страницы
onMounted(() => {
  fetchTopics()
  fetchMyQuestions()
})
</script>
<style scoped>
/* Ограничение длины текста до 2 строк с троеточием (для десктопной таблицы) */
.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Ограничение длины текста до 3 строк с троеточием (для мобильных карточек) */
.text-truncate-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Сохранение абзацев и переносов строк (\n), которые ввел преподаватель */
.whitespace-pre-line {
  white-space: pre-line;
}

/* Избавление от лишней белой подложки под таблицей */
.background-transparent {
  background: transparent !important;
}
</style>


